import { royalBluePalette } from '../../../themes/colors';

export const titleLightThemeV2 = {
  styles: {
    fontFamily: 'Ubuntu, sans-serif',
  },
  fontWeight: 700,
  color: royalBluePalette[1000],
};
